<ngx-awesome-uploader  #uploader [captions]="captions" [adapter]="adapter"
    (uploadFail)="onUploadFail($event)" (uploadSuccess)="onUploadSuccess($event)"
    (removeSuccess)="onRemoveSuccess($event)">
</ngx-awesome-uploader>
